import React from 'react';
import { FormProvider } from 'react-hook-form';

import FlowRendererComponent from "conversie-flow-bundle/assets/js/components/flow/renderers/FlowRendererComponent";
import FlowFieldChoice from "conversie-flow-bundle/assets/js/components/flow/fields/FlowFieldChoice";

/* Components */
import ConversionComponentTradeInVehicle from "./components/ConversionComponentTradeInVehicle";
import ConversionComponentFinanceCalculator from "./components/ConversionComponentFinanceCalculator";
import ConversionComponentLeaseCalculator from "./components/ConversionComponentLeaseCalculator";
import ConversionComponentsummary from "./components/ConversionComponentSummary";
import ConversionFieldChoice from "./fields/ConversionFieldChoice";
import ConversionFieldChoiceVwpfs from "./fields/ConversionFieldChoiceVwpfs";
import ConversionFlowSubmit from "./ConversionFlowSubmit";

/* Icons */
import PhoneIcon from '~/../symbols/phone-vdp.svg';

/* Common */
import { Button } from '~/components/common';

/* Utilities */
import { trans } from '~/utilities';
import ConversionFieldUpload from './fields/ConversionFieldUpload';
import ConversionFlowDatalayer from './ConversionFlowDatalayer';

export default class ConversionFlowInPageForm extends React.Component {
    constructor(props) {
        super(props);
    }

    shouldComponentUpdate(nextProps) {
        const activeStep = nextProps?.flow?.steps?.find((step) => step.active);

        if (nextProps.inPage) return true;
        if (activeStep?.position === 1) return true;

        return false;
    }

    render() {
        const { form, flow, doRequest, handleClose, locationPhone, flowDisclaimer, Banner, inPage, showDatalayer, datalayerData } = this.props;
        const activeStep = flow?.steps?.find((step) => step.active);
        const isLastStep = activeStep?.last;

        return (
            <form noValidate onSubmit={form.handleSubmit(() => doRequest({ action: 'submit' }, 'submitting'))}>
                {showDatalayer ? (
                    <ConversionFlowDatalayer activeStepId={flow?.steps?.find(step => step.active)?.id} flow={flow} datalayerData={datalayerData}/>
                ) : null}
                <FormProvider {...form}>
                    <div className="row gutters-2">
                        {(inPage && isLastStep) ? (
                            <div className="col-12">
                                {flow?.form.intro}
                            </div>
                        ) : (
                            <FlowRendererComponent
                            components={flow?.form?.components}
                            path={`form.components`}
                            id={`form-${flow?.flowId}.components`}
                            renderComponent={(component, props) => {
                                if (component.name === 'trade-in-vehicle') {
                                    return (
                                        <ConversionComponentTradeInVehicle
                                            {...props}
                                        />
                                    );
                                }

                                if (component.name === 'finance-calculator' || component.name === 'financial-lease-calculator') {
                                    return (
                                        <ConversionComponentFinanceCalculator
                                            {...props}
                                        />
                                    );
                                }

                                if (component.name === 'vwpfs-lease-calculator') {
                                    return (
                                        <ConversionComponentLeaseCalculator
                                            {...props}
                                        />
                                    );
                                }

                                if (component.name === 'summary') {
                                    return (
                                        <ConversionComponentsummary
                                            summary={flow?.summary}
                                        />
                                    );
                                }
                            }}
                            renderField={(field, props) => {
                                // Tiles look the same in every flow: the private lease calculator's (WAAL-1272).
                                if (field?.view === 'choice' && ['choice-radio', 'choice-checkbox'].includes(field.type)) {
                                    return (
                                        <ConversionFieldChoiceVwpfs
                                            {...props}
                                            customControlClassName="custom-control--expanded"
                                            colClassName="col-12"
                                            inputType={field.type === 'choice-radio' ? 'radio' : 'checkbox'}
                                        />
                                    );
                                }

                                if (field?.view && field.type === 'choice-radio') {
                                    return (
                                        <ConversionFieldChoice
                                            {...props}
                                            customControlClassName={`custom-control--${field.view}`}
                                            choiceColClassName={props?.colClassName}
                                            colClassName="col-12"
                                            inputType="radio"
                                        />
                                    );
                                }

                                if (field.type === 'file') {
                                    return (
                                        <ConversionFieldUpload
                                            {...props}
                                            customControlClassName={`custom-control--${field.view}`}
                                            choiceColClassName={field.view === 'choice' ? 'col' : props?.colClassName}
                                            colClassName="col-12 col-lg-6"
                                        />
                                    );
                                }

                                if (field?.view && field.type === 'choice-checkbox') {
                                    return (
                                        <ConversionFieldChoice
                                            {...props}
                                            customControlClassName={`custom-control--${field.view}`}
                                            choiceColClassName={props?.colClassName}
                                            colClassName="col-12"
                                            inputType="checkbox"
                                        />
                                    );
                                }

                                if (field.type === 'interest-checkbox') {
                                    return (
                                        <FlowFieldChoice
                                            {...props}
                                            inputType="checkbox"
                                        />
                                    );
                                }
                            }}
                        />
                        )}
                        {flow?.form?.buttonLabel && (
                            <div className="col-12 mt-2">
                                <div className="row gutters-2">
                                    <div className="col-12">
                                        <ConversionFlowSubmit
                                            flow={flow}
                                            handleClose={handleClose}
                                            className={'mt-2 text-truncate btn-block'}
                                        />
                                    </div>
                                    {locationPhone && (
                                        <div className="col-12">
                                            <Button
                                                href={`tel:${locationPhone}`}
                                                className="btn--reversed gap-2 justify-content-center"
                                                theme="outline-base"
                                                showTitle={true}
                                                title={`Bel ons op ${locationPhone}`}
                                                showIcon={true}
                                                icon={PhoneIcon}
                                                iconSize={24}
                                            />
                                        </div>
                                    )}
                                </div>
                            </div>
                        )}
                        {Banner && (
                            <>
                                <div className="col-12 mt-4">
                                    <div key={'banner'}>
                                        <Banner/>
                                    </div>
                                    <p className="text-muted--60 text--12 mt-3">{trans('app.flow.finance.calculator.rate_title', {'finance_rate': (flow.summary.vehicle.finance * 100)})}</p>
                                </div>
                            </>
                        )}
                        {flowDisclaimer !== '' &&
                            <div className="col-12">
                                <p className="text-muted--60 text--14">{flowDisclaimer}</p>
                            </div>
                        }
                    </div>
                </FormProvider>
            </form>
        )
    }
}
